var render, staticRenderFns
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24603b2d')) {
      api.createRecord('24603b2d', component.options)
    } else {
      api.reload('24603b2d', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/order_manage/external_employees/components/material.vue"
export default component.exports